<template>
  <div class="container bg1">
    <h3>Stocks List</h3>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Name</th>
          <th>NSE Code</th>
          <th>BSDE Code</th>
          <th>Stock Release / Creation Date</th>
          <th>Report</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="data in stocksList"
          :key="data.id"
        >
          <td>{{ data.name }}</td>
          <td>{{ data.nseCode }}</td>
          <td>{{ data.bseCode }}</td>
          <td>{{ beautifyDate( data.createdAt) }}</td>
          <td><a
              v-show="data.reportLink"
              :href="data.reportLink"
              target="_blank"
            >Report</a></td>
          <td @click="addNewUpdate(data)">
            <v-icon class="pt-2 ml-4">add</v-icon>
          </td>
          <td @click="veiwOldUpdates(data)">
            <v-icon class="pt-2 ml-4">list</v-icon>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- Add new Updates -->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500"
    >
      <v-card class="pa-4">
        <v-card-title
          class="headline"
          v-if="currentStock"
        >Add Update for {{ currentStock.name }}</v-card-title>
        <div class="container">
          <div class="row">
            <div class="col-m-12">
              <div class="form-group">
                <label for="sel1">Select Update Type:</label>
                <select
                  class="form-control"
                  id="sel1"
                  v-model="update.type"
                >
                  <option
                    v-for="item in updateTypeList"
                    :key="item.id"
                    :value="item.text"
                  >{{item.text}}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="Description">Description</label>
                <input
                  class="form-control"
                  type="text"
                  placeholder="Description"
                  v-model="update.description"
                  id="Description"
                >
              </div>
              <div class="form-group">
                <label for="report_link">Report Link:</label>
                <input
                  class="form-control"
                  type="text"
                  placeholder="Report Link"
                  v-model="update.report_link"
                  id="report_link"
                >
              </div>
              <button
                class="btn btn-default"
                @click="saveUpdate"
              >Save Data </button>
              <button
                class="btn btn-default"
                @click="closeDialog"
              >Close </button>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- Add new updates  -->
    <!-- View Old updates  -->
    <v-dialog
      v-model="veiwUpdates"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title
          class="headline"
          v-if="currentStock"
        >All updates for {{ currentStock.name }}</v-card-title>
        <ul>
          <li>

          </li>
        </ul>
        <table class="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Type</th>
              <th>Description</th>
              <th>Report Link</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in updates"
              :key="item.id"
            >
              <td>{{ beautifyDate(item.createdAt) }}</td>
              <td> {{item.type}}</td>
              <td> {{item.description}}</td>
              <td><a
                  v-if="item.report_link"
                  :href="item.report_link"
                  target="_blank"
                >Report</a></td>
            </tr>
          </tbody>
        </table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            @click="veiwUpdates = false; currentStock = null"
          >Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- View Old updates  -->
  </div>
</template>

<script>
  import lb from "../../util/lb";
  import { mapGetters } from "vuex";

  export default {
    name: "GetStockList",
    computed: {
      ...mapGetters(["user"])
    },
    data() {
      return {
        stocksList: [],
        updateTypeList: [],
        dialog: false,
        veiwUpdates: false,
        currentStock: null,
        updates: [],
        update: {
          type: null,
          description: null,
          report_link: null
        }
      };
    },
    methods: {
      beautifyDate(date) {
        return date ? new Date(date).toDateString() : "N/A";
      },
      addNewUpdate(data) {
        this.dialog = true;
        this.currentStock = data;
      },
      veiwOldUpdates(data) {
        this.currentStock = data;
        this.veiwUpdates = true;
        lb.get("/api/Updates", {
          params: {
            filter: {
              where: {
                stockId: this.currentStock.id
              }
            }
          }
        })
          .then(({ data }) => {
            this.updates = data;
          })
          .catch(e => {
            console.log(e);
            this.$toasted.console.error();
            "Some Error Occurred",
              {
                position: "bottom-right",
                duration: 2000
              };
          });
      },
      saveUpdate() {
        lb.post("/api/Updates", {
          type: this.update.type,
          description: this.update.description,
          report_link: this.update.report_link,
          stockId: this.currentStock.id
        })
          .then(() => {
            this.dialog = false;
            this.$toasted.show("Data saved", {
              position: "bottom-right",
              duration: 2000
            });
            this.update = {
              type: null,
              description: null,
              report_link: null
            };
            this.currentStock = null;
          })
          .catch(e => {
            this.currentStock = null;
            this.$toasted.console.error();
            "Some Error Occurred",
              {
                position: "bottom-right",
                duration: 2000
              };
            console.log(e);
          });
      },
      closeDialog() {
        this.currentStock = null;
        this.dialog = false;
        this.update = {
          type: null,
          description: null,
          report_link: null
        };
      }
    },
    mounted() {
      if (!this.user) {
        this.$router.push("/login");
        return;
      }
      if (this.user.admin != 999) {
        this.$router.push("/myaccount");
        return;
      }
      lb.get("/api/Stocks", {
        params: {
          order: "createdAt ASC"
        }
      }).then(({ data }) => {
        this.stocksList = data.map(item => {
          if (item.buy_date) {
            item.buy_date = new Date(item.buy_date).toDateString();
          }
          if (item.sell_date) {
            item.sell_date = new Date(item.sell_date).toDateString();
          }
          return item;
        });
        lb.get("/api/Updates/getupdatetype")
          .then(({ data }) => {
            this.updateTypeList = data;
          })
          .catch(e => console.log(e));
      });
    }
  };
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/admin/StockList.vue